module.exports = __webpack_public_path__ + "img/Zhengyou_Zhang.94592f4e.jpg";